import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import { makeStyles, Theme, createStyles, CssBaseline, CircularProgress } from "@material-ui/core";
import { useDispatch } from "react-redux";

import { AuthState, getUser, setUserData } from './app/reducer/auth.reducer';
import { useAppSelector } from './app/hooks';

import AppHeader from "./components/AppHeader";
import AppDrawer from "./components/AppDrawer";

import Login from './pages/Login';
import Home from './pages/Home';

import Projects from './pages/projects';
import EditProject from './pages/projects/EditProject';

import Fans from './pages/Fans';

import GADrawings from "./pages/GADrawings";
import BladeModels from "./pages/BladeModels";
import Hubs from "./pages/Hubs";
import OctaveBands from "./pages/OctaveBands";

import Users from './pages/users';
import EditUser from "./pages/users/EditUser";
import { LOGIN_BG } from "./assets";
import SearchFanScreen from "./pages/SearchFanScreen";
import { HelpProvider,useHelp } from "./utils/HelpContext";
import ArchieveFanScreen from "./pages/ArchieveFanScreen";


const drawerWidth = 210;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 20,
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      backgroundColor:'#48bc97',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      backgroundColor:'#48bc97',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9) + 1,
      },
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
  }),
);


declare interface RouteProps {
  path: string;
  Component: React.ComponentType<any>;
  isAuth?: true | false | 'loading';
}

const PrivateRoute = ({ isAuth, Component }: RouteProps): JSX.Element => (
  <Route
    render={(props) => isAuth === true
      ? <Component {...props} />
      : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />}
  />
);

export function Site() {
  const [loading, setLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const classes = useStyles();

  const userData: AuthState = useAppSelector(getUser);
  const { isAuth, user } = userData;

  useEffect(() => {

    if (isAuth) {
      return;
    };

    const username = localStorage.getItem('username');
    const email = localStorage.getItem('email');
    const userTypeNum = localStorage.getItem('userType');
    const userID = localStorage.getItem('userID');
    if (username && userTypeNum && email) {

      const userType = parseInt(userTypeNum);
      dispatch(setUserData({ username, email, userType,userID }));

    }

    setLoading(false)

  }, []);

  return (
    <HelpProvider>
    <div className={classes.root}>
      <CssBaseline />
      {loading ?
        <div style={{ height: '500px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress
            size={50}
          />
        </div>
        :
        <Router>
          <React.Fragment>
            {isAuth && <AppHeader  classes={classes} open={open} isAuth={isAuth} user={user} handleDrawerOpen={handleDrawerOpen} />}
            {isAuth && user && <AppDrawer user={user} classes={classes} open={open} handleDrawerClose={handleDrawerClose} />}
          </React.Fragment>
          <main className={classes.content} style={isAuth?{ backgroundColor: '#718191', backgroundSize: "cover" }:{
              backgroundImage: `url(${process.env.PUBLIC_URL}/Background.jpg)`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundColor: "transparent",
            }}>
            <Switch>
              
              <Route path="/login"><Login /></Route>
              <PrivateRoute path="/projects/new" isAuth={isAuth} Component={EditProject}></PrivateRoute>
              <PrivateRoute path="/projects/edit" isAuth={isAuth} Component={EditProject}></PrivateRoute>
              <PrivateRoute path="/projects" isAuth={isAuth} Component={Projects}></PrivateRoute>
              <PrivateRoute path="/fans" isAuth={isAuth} Component={Fans}></PrivateRoute>
              <PrivateRoute path="/ga-drawings" isAuth={isAuth} Component={GADrawings}></PrivateRoute>
              <PrivateRoute path="/blade-models" isAuth={isAuth} Component={BladeModels}></PrivateRoute>
              <PrivateRoute path="/hubs" isAuth={isAuth} Component={Hubs}></PrivateRoute>

              <PrivateRoute path="/octave-bands" isAuth={isAuth} Component={OctaveBands}></PrivateRoute>

              <PrivateRoute path="/users/new" isAuth={isAuth} Component={EditUser}></PrivateRoute>
              <PrivateRoute path="/users/edit" isAuth={isAuth} Component={EditUser}></PrivateRoute>
              <PrivateRoute path="/users" isAuth={isAuth} Component={Users}></PrivateRoute>
              <PrivateRoute path="/search" isAuth={isAuth} Component={SearchFanScreen}></PrivateRoute>
              <PrivateRoute path="/archive" isAuth={isAuth} Component={ArchieveFanScreen}></PrivateRoute>
              <PrivateRoute path="/" isAuth={isAuth} Component={Home}></PrivateRoute>
            </Switch>
          </main>
        </Router>
      }
    </div>
    </HelpProvider>
  )

}
